import React, {useState} from "react";
import {Container, Row, Col, Button} from "react-bootstrap";
import Navbar from "../shared/navbar";
import Footer from '../shared/footer'
import {Switch} from "@mui/material";
import CheckCircle from '../../images/check-circle.png'
import { Slider } from '@mui/material';
import {new_trial_path} from "../../routes";


const FACT_LIST = [
  'Network Performance Monitoring',
  'Chrome Extension',
  'Minim veniam',
  'Dolor sit amet',
  'Excepteur sint',
  'Lorem ipsum',
  'Monitor device health',
  'Access IT',
  'Monitor remote ',
  'Monitor application'
]

const Index = () => {
  const [isAnnual, setAnnual] = useState(false)
  const [deviceNumber, setDeviceNumber] = useState(50)
  const [totalPrice, setTotalPrice] = useState(50)

  const deviceCalculateHandler = (e) => {
    setDeviceNumber(e.target.value)
    const remainDevice = e.target.value - 50
    const total = 50 + remainDevice
    setTotalPrice(total)
  }

  return (
    <>
      <Navbar/>
      <Container id="pricing">
        <Row className="pricing-container">
          <Col xs={12}>
            <Row>
              <Col xs={12}>
                <div className="intro-container">
                  <div className="pricing-plan">Pricing Plan</div>
                  <div className="pay-header">Pay as your grow</div>
                  <div className="switch-container">
                    <span className={`${isAnnual ? 'active' : ''}`}>Monthly</span>
                    <Switch
                      onChange={() => setAnnual(!isAnnual)}
                    />
                    <span className={`${!isAnnual ? 'active' : ''}`}>Annually</span>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col xs={12} className="more-detail-wrapper">
                <div className="price-detail-container">
                  <div className="price-wrapper">
                    <div className="price-base"><span>$50</span>usd</div>
                    <div className="plan-intro">per month</div>
                  </div>
                  <div className="price-detail-description">
                    Includes first 50 monitored devices <strong className="bold">$1 per month&nbsp;</strong>
                    for each device over 50
                  </div>
                  <div className="action-options-container">
                    <div className="button-container">
                      <Button className="btn" id="start-free" onClick={() => window.location = new_trial_path() }>Start for free</Button>
                      <div className="price-tip">
                        Free for 30 days. <strong>Unlimited</strong> devices.
                        Cancel anytime.
                      </div>
                    </div>
                    {/*<div className="button-container">*/}
                    {/*  <Button className="btn" id="buy-now">Buy now</Button>*/}
                    {/*  <div className="price-tip">*/}
                    {/*    Don’t worry, we won’t charge*/}
                    {/*    you for the first 30 days*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                  </div>
                </div>
                <div className="fact-list">
                  <div className="list">
                    {
                      FACT_LIST.map((el, index) => (
                        <div key={index} className="list-item">
                          <div className="img-container">
                            <img src={CheckCircle}/>
                          </div>
                          <div className="desc">
                            {el}
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="pricing-calculator">
            <div className="header">
              Pricing Calculator
            </div>
            <div className="sub-header">
              Our pricing is designed to give you flexibility.
              At the end of each month we will adjust your billing
              based on the monthly active devices from the previous 30 days.
            </div>
            <div className="device-number">{deviceNumber} Devices</div>
            <div className="price-adjust-container">
              <Slider
                size="small"
                defaultValue={50}
                min={50}
                max={2500}
                aria-label="Small"
                valueLabelDisplay="auto"
                onChange={deviceCalculateHandler}
              />
            </div>
            <div className="total-price">
              <strong>${totalPrice} </strong>per month
            </div>
          </Col>
        </Row>
      </Container>
      <div id="custom-package-container">
        <div className="intro-container">
          <div className="header">Large volume, custom needs, or education</div>
          <div className="sub-header">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          </div>
        </div>
        <div>
          <Button
            id="contact-us"
          >
            Contact Us
          </Button>
        </div>
      </div>
    </>
  )
}

export default Index